var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "grid_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".grid_svg__cls-1{stroke-miterlimit:10;stroke-width:.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid_svg__grid"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M19.1 12.6h-5.9c-.3 0-.6.2-.6.6v5.9c0 .3.2.6.6.6h5.9c.3 0 .6-.2.6-.6v-5.9c0-.3-.2-.6-.6-.6ZM10.8 12.6H4.9c-.3 0-.6.2-.6.6v5.9c0 .3.2.6.6.6h5.9c.3 0 .6-.2.6-.6v-5.9c0-.3-.2-.6-.6-.6ZM19.1 4.4h-5.9c-.3 0-.6.2-.6.6v5.9c0 .3.2.6.6.6h5.9c.3 0 .6-.2.6-.6V5c0-.3-.2-.6-.6-.6ZM10.8 4.4H4.9c-.3 0-.6.2-.6.6v5.9c0 .3.2.6.6.6h5.9c.3 0 .6-.2.6-.6V5c0-.3-.2-.6-.6-.6Z",
    className: "grid_svg__cls-1"
  }))));
};
export default SvgGrid;